module.exports = __webpack_public_path__ + "img/104.ca9def50.jpg";